<template>
  <form-group :name="name" :label="label" :help-text="helpText" :error="error">
    <gallery-widget
        :value="value"
        :nullable="nullable"
        :company-id="companyId"
        @input="$emit('input', $event)"
    ></gallery-widget>
  </form-group>
</template>

<script>
import FormGroup from "@/vendor/forms/FormGroups/Block/FormGroup";
import GalleryWidget from "../Widgets/Gallery";

export default {
  components: {FormGroup, GalleryWidget},

  props: {
    "name": {},
    "label": {},
    "helpText": {"default": null},
    "value": {},
    "error": {},
    "nullable": {},
    companyId: {
      required: false,
      type: [String, Number],
    },
  }
}
</script>
